import React from 'react'
import styled, { css } from 'styled-components'
import { Button } from 'components'
import { WidthProps } from 'types/styled'
import { colors } from 'utils/colors'

interface ISwitchButton {
  onClickPrimary?: () => any | undefined
  onClickSecondary?: () => any | undefined
  primaryIcon?: any | undefined
  primaryLabel?: string | undefined
  secondaryLabel?: string | undefined
  secondaryIcon?: any | undefined
  value?: choices
  width?: WidthProps
}

const SwitchButtonWrapper = styled.div<ISwitchButton>`
  border-radius: 7px;
  border: 1px solid ${colors.blue1};
  box-shadow: inset 0 0 3px 1px rgba(143, 155, 179, 0.32);
  box-sizing: border-box;
  display: flex;
  height: 44px;
  margin: auto;
  padding: 3px;
  ${(p) =>
    p.width &&
    css`
      width: ${p.width}px;
    `}
`

const MutatedButton = styled(Button)`
  width: 50%;
  text-overflow: ellipsis;
  ${(p) =>
    p.variant === 'ghost' &&
    css`
      color: ${colors.disabledText};

      > svg {
        color: ${colors.disabledText};
      }
    `}
`
type choices = 'left' | 'right'

const SwitchButton: React.FC<ISwitchButton> = ({
  onClickPrimary,
  onClickSecondary,
  primaryIcon,
  primaryLabel,
  secondaryLabel,
  secondaryIcon,
  value = 'left',
  width,
}: ISwitchButton) => {
  const onClickToggle = (value: choices) => {
    if (value === 'left') {
      onClickPrimary && onClickPrimary()
    } else {
      onClickSecondary && onClickSecondary()
    }
  }
  return (
    <SwitchButtonWrapper width={width}>
      <MutatedButton
        variant={value === 'left' ? 'fill' : 'ghost'}
        icon={primaryIcon}
        onClick={() => onClickToggle('left')}
      >
        {primaryLabel}
      </MutatedButton>
      <MutatedButton
        variant={value === 'right' ? 'fill' : 'ghost'}
        icon={secondaryIcon}
        onClick={() => onClickToggle('right')}
      >
        {secondaryLabel}
      </MutatedButton>
    </SwitchButtonWrapper>
  )
}

export default SwitchButton
